import React, { useState, useEffect, useContext, useRef } from 'react';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import FormPermissionService from "../../../Setup/controller/FormPermissionController/FormPermissionController";
import JobPartsService from "../../Controller/JobPartsController";
import CreateJobModel from "./CreateJobPart";
import JobService from "../../Controller/JobController";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import PartService from "../../../Parts/Controller/PartController";
import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import HelpSite from "../../../Common/HelpLink";
import CurrencyConverter from '../../../../config/CurrencyConverter';
import { convertCurrency } from "../../../Purchasing/View/PurchaseOrderForms/CurrencyConverter";
import { handleChange, handleSubmit } from "../../Controller/CreateJobPartController";
import Select from 'react-select';
function PartStatus({ part }) {
    const getStatus = () => {
        if (parseFloat(part.vc_UnitOfSale) === parseFloat(part.dec_QtyAllocated)) {
            return "Full";
        } else if (parseFloat(part.dec_QtyAllocated) === parseFloat("0")) {
            return "Pending";
        } else {
            return "PART";
        }
    };

    return <span>{getStatus()}</span>;
}
function JobPartList({ JobID }) {
    const navigate = useNavigate();
    JobID = localStorage.getItem('JobID');

    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const RoleID = localStorage.getItem('RoleID');
    const HelpLink = localStorage.getItem('HelpLink');
    const pathname = "/job/job-part";
    const tableRef = useRef();
    const FormAction = "/JobsList";
    //FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);
    const [currentjobPart, setCurrenJobPart] = useState(null);
    const [modalInstance, setModalInstance] = useState(null);
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [jobPartsList, setJobPartsData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(true);

    const [isModalCreateOpen, setIsCreateModalOpen] = useState(false);
    const [isModalDepot, setIsModalDepot] = useState(false);
    const [selectedDepot, setSelectedDepot] = useState("");
    const [IssueStockID, setIssueStockID] = useState(0);
    const [depots, setSelectedDepotList] = useState([]);
    const [isClosed, SetIsClosed] = useState("0");
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [selectedParts, setSelectedParts] = useState([]);
    const [BaseCurrency, setBaseCurrency] = useState(null);
    const [currencyList, setCurrencies] = useState([]);
    const [StockLocationList, setStockLocation] = useState([]);
    const [ConvRate, setConvRate] = useState('1.00');
    const [formData, setFormData] = useState({
        FK_Stock_ID: 0,
        FK_Issue_ID: JobID,
        PK_StockLocation_ID: 0,
        DepotQuantity: "0.00",
        mon_SalesPrice: "0.00",
        vc_UnitOfSale: "1",
        vc_StockCode: "",
        vc_StockName: "",
        mon_StockPrice: "0.00",
        mon_AverageCostPrice: "0.00",
        vc_CommodityCode: "",
        vc_Description: "0.00",
        mon_LastPurchasePrice: "0.00",
        dt_LastSaleDate: "",
        dt_StockTakeDate: "",
        dec_TaxCode: "",
        snt_PurchaseNominalCode: "",
        snt_SalesNominalCode: "",
        PK_Stock_ID: "",
        LocationID: ""
    });
    const [parts, setPartData] = useState([]);
    const [errors, setErrors] = useState({});
    const fetchJobParts = async () => {
        try {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().destroy();
            }
            // Saqib Salam
            const jobData = await JobPartsService.GetJobParts(redirectCallback, JobID);
            const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
            setBaseCurrency(listOfCurreny[0].Symbol)
            setJobPartsData(jobData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            "paging": true,
            "searching": true,
            "info": true,
            order: [[0, 'desc']],
        });
    };
    const fetchParts = async (ClientCompanyID) => {
        try {
            const redirectCallback = () => navigate('/');
            const data = await PartService.GetPartsByUser(redirectCallback);
            setPartData(data);
        } catch (error) {
            console.error('Error fetching parts:', error);
        }
    };
    useEffect(() => {
        fetchJobDetail();
        if (jobPartsList.length > 0) {
            initDataTable();
        }
    }, [jobPartsList]);

    useEffect(() => {
        SetIsClosed(localStorage.getItem("Closed"));
        fetchJobParts();
        fetchParts();
    }, [JobID, localStorage.getItem("Closed")]);

    const fetchJobDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (JobID > 0) {

                const jobDetail = await JobService.GetJobByID(redirectCallback, JobID);
                await fetchCurrencyConvRate(jobDetail[0].Symbol);
                SetIsClosed(jobDetail[0].IsCompleted);

            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    const fetchCurrencyConvRate = async (newCurrencySymbol) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const rateConv = await convertCurrency(BaseCurrency, newCurrencySymbol, currencyList, "0");
            setConvRate(rateConv);
        } catch (error) {
            console.error('Error fetching Agreement Notifications:', error);
        }
    };

    const handleCreateJobPartClick = () => {
        setIsModalOpen(false);
        setIsCreateModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };


    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation(); // Prevent the row click event

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await JobPartsService.DeleteJobPart(redirectCallback, ID);
                    if ($.fn.DataTable.isDataTable(tableRef.current)) {
                        $(tableRef.current).DataTable().destroy();
                    }
                    fetchJobParts();
                    let JobCostID = localStorage.getItem('JobCostID');
                    JobCostID = JobCostID + 1;
                    localStorage.setItem('JobCostID', JobCostID);
                    redirectUserList();
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };
    const handleJobSaveClick = async (JobID) => {
        try {
            debugger;
            const jobData = await JobPartsService.UpdatePendingParts(redirectCallback, JobID);
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().destroy();
            }
            fetchJobParts();
            let JobCostID = localStorage.getItem('JobCostID');
            JobCostID = JobCostID + 1;
            localStorage.setItem('JobCostID', JobCostID);
            redirectUserList();

        } catch (error) {
            console.error('Error deleting Site:', error);
        }

    };
    const redirectUserList = () => {
        navigate('/JobsList?saved=true');
    };
    const handleSuccess = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchJobParts(); // Refresh the list after submission
        handleCloseModal(); // Close the modal
        //   redirectUserList();

    };
    const handelSelectDepot = async (event, PK_IssueStock_ID, PartID) => {
        event.stopPropagation();
        setIssueStockID(PK_IssueStock_ID);
        await fetchStockLocations(PartID);
        setIsModalDepot(true);
    };

    // Handle closing the modal
    const closeModal = () => {
        setIsModalDepot(false);
    };
    const handleDepotSubmit = () => {
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        JobPartsService.AddStockLocation(redirectCallback, IssueStockID, selectedDepot);
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchJobParts();
        closeModal(); // Close the modal after submitting
    };
    const fetchStockLocations = async (PartID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const listOfLocations = await PartService.GetStockAndUserLocation(redirectCallback, PartID);
            return listOfLocations;
        } catch (error) {
            console.error('Error fetching locations:', error);
        }
    };
    const handleFormSubmit = async (event) => {
        event.preventDefault();

        debugger;
        try {
            const redirectUserList = () => {
                navigate('/JobsList?saved=true');
            };
            formData.ID = 0;
            formData.FK_Issue_ID = JobID;

            const formDataWithParts = {
                formData: formData,
                selectedParts: [formData]
            };

            const Message = await handleSubmit(event, formDataWithParts, setFormData, setErrors);

            if (Message === "Data saved successfully") {
                let JobCostID = localStorage.getItem('JobCostID');
                JobCostID = JobCostID + 1;
                localStorage.setItem('JobCostID', JobCostID);
                // handleSuccess();
                //    redirectUserList();
            }
            else {
                setShowSuccessMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 5000);
            }
            await fetchJobParts();
            setIsCreateModalOpen(false);
            setIsModalOpen(true);

        } catch (error) {
            console.error('Error submitting form:', error);
            setErrors({ submit: 'An error occurred while submitting the form. Please try again.' });
        }
    };
    const handleFieldChange = async (event, fieldName) => {
        debugger;
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));

        if (fieldName === "FK_Stock_ID") {
            const listOfLocations = await fetchStockLocations(value);
            setStockLocation(listOfLocations);
            const Part = await PartService.GetPartByID(redirectCallback, value);
            setFormData(prevState => ({
                ...prevState,
                PK_StockLocation_ID:
                    listOfLocations && listOfLocations.length > 0
                        ? listOfLocations[0].PK_StockLocation_ID
                        : "0",
                DepotQuantity: Part[0].dec_FreeStock,
                mon_SalesPrice: Part[0].mon_SalesPrice,
                vc_StockCode: Part[0].vc_StockCode,

                vc_StockName: Part[0].vc_StockName,
                mon_StockPrice: Part[0].mon_StockPrice,
                mon_AverageCostPrice: Part[0].mon_AverageCostPrice,
                vc_CommodityCode: Part[0].vc_CommodityCode,
                vc_Description: Part[0].vc_Description,
                mon_LastPurchasePrice: Part[0].mon_LastPurchasePrice,

                dt_LastSaleDate: Part[0].dt_LastSaleDate,
                dt_StockTakeDate: Part[0].dt_StockTakeDate,
                dec_TaxCode: Part[0].dec_TaxCode,
                snt_PurchaseNominalCode: Part[0].snt_PurchaseNominalCode,
                snt_SalesNominalCode: Part[0].snt_SalesNominalCode,
                dec_Quantity: Part[0].dec_Quantity,
                PK_Stock_ID: Part[0].PK_Stock_ID,
                LocationID: Part[0].PK_StockLocation_ID,

            }));
        }

    };
    return (
        <div>

            <div className="row">
                <div className="col-xl-12">
                    <div className="card mb-30">
                        <div className="card-body">
                            <div className="row mb-3">
                                <div className="col-sm-12" style={{ textAlign: "right" }}>
                                    <button className='btn btn-primary btn-sm' onClick={handleCreateJobPartClick} disabled={isClosed === '1' || isClosed === 1}>
                                        <i className="icofont-plus" aria-hidden="true"> Add</i>
                                    </button>
                                </div>
                            </div>

                            {(isModalCreateOpen &&
                                <form onSubmit={handleFormSubmit}>
                                    <div className="card shadow-sm border-0">
                                        <div className="list-group m-2">
                                            <div className=" list-group-item">

                                                <strong> Select Part:</strong>

                                                <span className="d-block mt-1">
                                                    <Select
                                                        style={{ "width": "30px" }}
                                                        name="FK_Stock_ID"
                                                        placeholder="Select Part"
                                                        options={parts.map(part => ({
                                                            value: part.PK_Stock_ID,
                                                            label: `${part.vc_StockCode} - ${part.vc_StockName}`
                                                        }))}

                                                        onChange={(selectedOption) => {
                                                            const fakeEvent = {
                                                                target: {
                                                                    name: "FK_Stock_ID",
                                                                    value: selectedOption.value
                                                                }
                                                            };
                                                            handleFieldChange(fakeEvent, 'FK_Stock_ID');
                                                        }}
                                                    />
                                                </span>

                                            </div>

                                            <div className="list-group-item">

                                                <strong> Select Depot:</strong>
                                                <span className="d-block mt-1">
                                                    <select className="form-control" name="PK_StockLocation_ID" value={formData.PK_StockLocation_ID} onChange={(e) => handleFieldChange(e, 'PK_StockLocation_ID')}>
                                                        <option value=""> Select Depot </option>
                                                        {StockLocationList.map((record) => (
                                                            <option key={record.PK_StockLocation_ID} value={record.PK_StockLocation_ID}>{record.vc_Name}</option>
                                                        ))}
                                                    </select>
                                                </span>

                                            </div>
                                            <div className="list-group-item">
                                                <strong>Free Stock:</strong>
                                                <span className="d-block mt-1">{formData.DepotQuantity}</span>
                                            </div>
                                            <div className="list-group-item">
                                                <strong>Sale Price:</strong>
                                                <span className="d-block mt-1">{formData.mon_SalesPrice}</span>
                                            </div>
                                            <div className="list-group-item">
                                                <strong>Quantity:</strong>
                                                <span className="d-block mt-1">
                                                    <input
                                                        type="text"
                                                        name="vc_UnitOfSale"
                                                        className="form-control"
                                                        value={formData.vc_UnitOfSale}
                                                        onChange={(e) => handleFieldChange(e, 'vc_UnitOfSale')}
                                                    />

                                                </span>
                                            </div>

                                        </div>
                                        <div className="col-sm-12" style={{ textAlign: "right" }}>
                                            <button className="btn btn-success btn-sm w-100">
                                                Save
                                            </button>

                                        </div>
                                    </div>
                                </form>
                            )}

                            {(isModalOpen &&
                                <div className="table-responsive">

                                    <div style={{ maxHeight: "550px", overflow: "auto" }}>

                                        <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>

                                            <tbody>
                                                {jobPartsList.map((part, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td style={{
                                                                fontWeight: 'bold',
                                                                padding: '10px',
                                                                width: '70%',
                                                                whiteSpace: 'normal',
                                                                
                                                            }}>
                                                                {part.vc_StockCode}
                                                            </td>
                                                            <td style={{
                                                                textAlign: 'right',
                                                                padding: '10px',
                                                                fontWeight: 'bold',
                                                                width: '30%'
                                                            }}>
                                                                {part.vc_UnitOfSale} {part.Measurment}
                                                            </td>
                                                        </tr>
                                                        <tr key={index}>
                                                            <td colSpan="2" style={{
                                                                padding: '11px',
                                                                whiteSpace: 'normal',
                                                                wordBreak: 'break-word',
                                                                borderBottom: '1px solid #ccc',
                                                            }}>
                                                                {part.vc_Description}
                                                            </td>
                                                        </tr>
                                                    </>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {isModalDepot && (
                <div className="modal fade jobDepotModel show d-block" id="jobDepotModel" tabIndex="-1" aria-labelledby="jobDepotModelLabel" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog modal-sm">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">Add Depot</h5>
                                <button type="button" className="close" aria-label="Close" onClick={closeModal}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body" style={{ "maxHeight": "300px", "overflow": "auto", "marginTop": "20px" }}>
                                <div className="row mb-3" style={{ "marginLeft": "0px", 'marginRight': '0px' }}>
                                    <label htmlFor="CompanyName" className="col-sm-5 col-form-label">Select Depot</label>

                                    <div className="col-sm-7">
                                        <select className='form-control' value={selectedDepot} onChange={(e) => setSelectedDepot(e.target.value)}>
                                            <option value="">Select Depot</option>
                                            {depots.map((depot) => (
                                                <option value={depot.PK_StockLocation_ID}>
                                                    {depot.vc_Name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "0px", 'marginRight': '0px', float: "right" }}>
                                    <div className="col-sm-12">
                                        <button onClick={handleDepotSubmit} className="btn btn-primary">
                                            Submit
                                        </button>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}

export default JobPartList;
